import { PERFORMANCE_METRICS_SPREADSHEET_COLUMNS } from './performance_metrics/config/sheetTitles';

export const LTM_REVENUE_MULTIPLE_COLUMN = 'C';
export const NTM_REVENUE_MULTIPLE_COLUMN = 'F';
export const LTM_EBITDA_MULTIPLE_COLUMN = 'I';
export const NTM_EBITDA_MULTIPLE_COLUMN = 'K';

export const ALIAS_LEGEND_MAP: { [key: string]: string } = {
  ltm_revenue_multiple_premium_over_median: LTM_REVENUE_MULTIPLE_COLUMN,
  ntm_revenue_multiple_premium_over_median: NTM_REVENUE_MULTIPLE_COLUMN,
  ltm_ebitda_multiple_premium_over_median: LTM_EBITDA_MULTIPLE_COLUMN,
  ntm_ebitda_multiple_premium_over_median: NTM_EBITDA_MULTIPLE_COLUMN,
};

export const PANEL_ID_PREFIX = 'calibration_performance_';

export const PERFORMANCE_METRICS_OFFSET = 2;

export const REVENUE_CELL_ALIAS_IDENTIFIER = 'revenue';
export const EBITDA_CELL_ALIAS_IDENTIFIER = 'ebitda';

export const ZERO_EXCLUDED_COLUMNS: number[] = [
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.TITLE,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.ENTERPRISE_VALUE,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.LTM_REVENUE,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.LTM_REVENUE_GROWTH,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.NTM_REVENUE,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.NTM_REVENUE_GROWTH,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.LTM_EBITDA,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.NTM_EBITDA,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.GROSS_MARGIN,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.EBITDA_MARGIN,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.TANGIBLE_BOOK,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.NET_INCOME,
];

export const NON_POSITIVE_EXCLUDED_COLUMNS: number[] = [
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.LTM_REVENUE_MULTIPLE,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.NTM_REVENUE_MULTIPLE,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.LTM_EBITDA_MULTIPLE,
  PERFORMANCE_METRICS_SPREADSHEET_COLUMNS.NTM_EBITDA_MULTIPLE,
];